import { render, staticRenderFns } from "./GlobalCompanyList.vue?vue&type=template&id=32cbc737&scoped=true"
import script from "./GlobalCompanyList.vue?vue&type=script&lang=js"
export * from "./GlobalCompanyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cbc737",
  null
  
)

export default component.exports